import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import { useAddTaskMutation } from "../features/tasks/tasksApi";
import { useGetMembersQuery } from "../features/team/memberApi";

const AddTask = () => {
  const { data: projects, isSuccess: isProjectsSuccess } =
    useGetProjectsQuery();
  const { data: members, isSuccess: isMembersSuccess } = useGetMembersQuery();
  const [addTask, { isSuccess, data }] = useAddTaskMutation();

  const [name, setName] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [selected, setSelected] = useState("");
  const [date, setDate] = useState("");
  const [member, setMember] = useState({});
  const [project, setProject] = useState({});

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    addTask({
      taskName: name,
      teamMember: member,
      project: project,
      deadline: date,
    });
    navigate("/");
  };
  const handleProjectChange = (e) => {
    const selectedProjectDetails = projects.find(
      (pro) => pro.projectName === e.target.value
    );
    setSelected(e.target.value);
    setProject(selectedProjectDetails);
  };
  const handleMemberChange = (e) => {
    const selectedMemberDetails = members.find(
      (mem) => mem.name === e.target.value
    );
    setAssignTo(e.target.value);
    setMember(selectedMemberDetails);
  };

  return (
    <div className="text-[#111827]">
      <div className="container relative">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Create Task for Your Team
          </h1>

          <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="fieldContainer">
                <label htmlFor="lws-taskName">Task Name</label>
                <input
                  type="text"
                  name="taskName"
                  id="lws-taskName"
                  required
                  placeholder="Implement RTK Query"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="fieldContainer">
                <label>Assign To</label>
                <select
                  name="teamMember"
                  id="lws-teamMember"
                  required
                  value={assignTo}
                  onChange={handleMemberChange}
                >
                  <option value="" hidden>
                    Select Team Member
                  </option>

                  {isMembersSuccess &&
                    members?.map((member) => (
                      <option key={member.name} value={member.name}>
                        {member.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="fieldContainer">
                <label htmlFor="lws-projectName">Project Name</label>
                <select
                  id="lws-projectName"
                  name="projectName"
                  required
                  value={selected}
                  onChange={handleProjectChange}
                >
                  <option value="" hidden>
                    Select Project
                  </option>
                  {isProjectsSuccess &&
                    projects?.map((project) => (
                      <option
                        key={project.projectName}
                        value={project.projectName}
                      >
                        {project.projectName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="fieldContainer">
                <label htmlFor="lws-deadline">Deadline</label>
                <input
                  type="date"
                  name="deadline"
                  id="lws-deadline"
                  required
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div className="text-right">
                <button type="submit" className="lws-submit">
                  Save
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddTask;
